import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import {
  Database, ShieldAlert, AlertTriangle, Cuboid, AlertOctagon, Tag,
  Image as ImageIcon, FileSpreadsheet, ShieldCheck, BookOpen, History,
  ScrollText, Building2, LibraryBig, Wrench, FileUp, Users, Download,
} from "lucide-react";

const ICON_MAP = {
  "database": Database,
  "shield-alert": ShieldAlert,
  "alert-triangle": AlertTriangle,
  "cuboid": Cuboid,
  "alert-octagon": AlertOctagon,
  "tag": Tag,
  "image": ImageIcon,
  "file-spread": FileSpreadsheet,
  "shield-check": ShieldCheck,
  "book-open": BookOpen,
  "history": History,
  "scroll-text": ScrollText,
  "building": Building2,
  "library": LibraryBig,
  "wrench": Wrench,
  "file-up": FileUp,
  "users": Users,
  "download": Download,
};

function ViewNodeImpl({ data }) {
  const Icon = ICON_MAP[data.icon] || Database;
  const hasData = data.count_label && data.count_label !== "—";
  const dim = !!data.dim;
  const highlight = !!data.highlight;
  return (
    <div
      data-testid={`fishbone-view-${data.id}`}
      style={{
        minWidth: 130,
        padding: "7px 12px",
        background: hasData ? "#0c2030" : "#161b22",
        border: `1.25px solid ${highlight ? "#f59e0b" : hasData ? "#1e88e5" : "#334155"}`,
        borderRadius: 999,
        color: hasData ? "#7dd3fc" : "#94a3b8",
        opacity: dim ? 0.18 : 1,
        transition: "opacity 0.18s ease, border-color 0.15s ease",
        cursor: "pointer",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <Handle type="target" position={Position.Top} style={{ background: "#475569", width: 5, height: 5 }} />
      <Handle type="source" position={Position.Bottom} style={{ background: "#475569", width: 5, height: 5 }} />
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <Icon size={13} strokeWidth={1.6} />
        <span style={{ fontSize: 11.5, fontWeight: 600 }}>{data.name}</span>
      </div>
      <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 2, fontFamily: "'JetBrains Mono', monospace" }}>
        {data.count_label}
      </div>
    </div>
  );
}

export default memo(ViewNodeImpl);
